// Shared subscription keyword dataset used by bank analyzer and Gmail scanner

export const SHARED_SERVICE_KEYWORDS = [
    // Utilities / Bills / Insurance (Recurring Payments)
    ['Electric Utility', ['electric', 'electricity', 'power', 'energy', 'light bill', 'utility electric', 'duke energy', 'coned', 'con ed', 'pge', 'pg&e', 'sdge', 'socal edison', 'edison', 'pepco', 'dominion energy', 'national grid', 'evergy', 'xcel energy']],
    ['Gas Utility', ['natural gas', 'gas utility', 'gas company', 'atmos energy', 'centerpoint', 'peoples gas', 'southwest gas', 'spire energy']],
    ['Water Utility', ['water utility', 'waterworks', 'water bill', 'aqua water', 'sewer', 'wastewater', 'sanitation', 'stormwater']],
    ['Trash / Waste', ['waste management', 'republic services', 'trash service', 'garbage', 'sanitation', 'waste services']],
    ['Phone / Internet', ['phone bill', 'wireless bill', 'cellular', 'mobile bill', 'internet bill', 'broadband', 'fiber', 'dsl', 'telecom', 'isp']],
    ['Insurance Premium', ['insurance premium', 'policy premium', 'auto insurance', 'home insurance', 'renters insurance', 'life insurance', 'umbrella insurance']],

    // Streaming Video / TV
    ['Netflix', ['netflix', 'nflx', 'netflix.com', 'netflix inc']],
      ['Hulu', ['hulu', 'hulu.com']],
      ['Disney+', ['disney', 'disneyplus', 'disney plus', 'disney+']],
      ['Max', ['hbo', 'hbomax', 'hbo max', 'warner media', 'max.com']],
      ['Amazon Prime Video', ['prime video', 'primevideo', 'amzn prime']],
      ['Apple TV+', ['apple tv', 'appletv']],
      ['Paramount+', ['paramount', 'paramount plus', 'paramount+']],
      ['Peacock', ['peacock', 'nbcu', 'nbcuniversal', 'peacocktv']],
      ['YouTube Premium', ['youtube premium', 'yt premium', 'google*youtube', 'yt subs', 'youtube membership']],
      ['YouTube TV', ['youtube tv', 'yttv']],
      ['Sling TV', ['sling', 'sling tv', 'sling television']],
      ['fuboTV', ['fubo', 'fubotv', 'fubo tv']],
      ['Philo', ['philo']],
      ['Starz', ['starz', 'starz ent', 'starz entertainment']],
      ['Showtime', ['showtime', 'sho direct', 'showtime subscription']],
      ['ESPN+', ['espn', 'espn plus', 'espn+']],
      ['Discovery+', ['discovery', 'discovery plus', 'discovery+']],
      ['Crunchyroll', ['crunchyroll', 'crunchy roll']],
      ['CuriosityStream', ['curiosity', 'curiositystream']],
      ['AMC+', ['amc+', 'amcplus', 'amc plus']],
      ['BritBox', ['britbox']],
      ['Mubi', ['mubi']],
      ['Sundance Now', ['sundance']],
      ['MLB.TV', ['mlb.tv', 'mlb tv']],
      ['NFL Sunday Ticket', ['nfl sunday', 'sunday ticket']],
      ['NBA League Pass', ['nba league', 'league pass']],
      ['Charter Spectrum', ['charter comm', 'spectrum']],
      ['Time Warner Cable', ['time warner cable', 'twc']],
      ['Mediacom', ['mediacom']],
      ['RCN Cable', ['rcn cable']],
      ['Viaplay', ['viaplay']],
      ['NowTV', ['nowtv', 'now tv']],
      ['Sky Showtime', ['sky showtime']],
      
      // Music & Audio
      ['Spotify', ['spotify', 'spotify ab', 'spotify usa']],
      ['Apple Music', ['apple music', 'itunes.com/bill', 'apple.com/bill']],
      ['YouTube Music', ['youtube music', 'yt music', 'yt music premium']],
      ['Amazon Music', ['amazon music', 'amzn music', 'amzn digital music']],
      ['Tidal', ['tidal', 'tidal music']],
      ['Pandora', ['pandora', 'pandora media']],
      ['SiriusXM', ['sirius', 'siriusxm', 'sirius xm radio', 'sxm']],
      ['Audible', ['audible', 'audible*', 'audible.com membership']],
      ['Calm', ['calm', 'calm.com']],
      ['Headspace', ['headspace', 'headspace.com']],
      ['Qobuz', ['qobuz']],
      ['SoundCloud', ['soundcloud']],
      ['TuneIn', ['tunein']],
      ['Podcast Subscription', ['podcast subscription', 'spotify podcast']],
      
      // Dating Apps
      ['Tinder', ['tinder']],
      ['Bumble', ['bumble']],
      ['Hinge', ['hinge']],
      ['OkCupid', ['okcupid']],
      ['Match.com', ['match.com', 'match']],
      ['eHarmony', ['eharmony']],
      ['Coffee Meets Bagel', ['coffee meets bagel', 'cmb']],
      
      // Social Platforms
      ['Reddit Premium', ['reddit']],
      ['Discord Nitro', ['discord', 'discord*nitro']],
      ['Snapchat+', ['snapchat', 'snap inc*plus']],
      ['Patreon', ['patreon', 'patreon*membership']],
      ['OnlyFans', ['onlyfans', 'onlyfans.com', 'of payments']],
      ['Twitch', ['twitch', 'twitch subscr', 'twitch interactive']],
      ['BeReal Plus', ['bereal plus']],
      
      // Cloud Storage / Backup
      ['Google One', ['google one', 'googleone', 'google storage plan']],
      ['iCloud+', ['icloud', 'apple icloud', 'icloud storage', 'icloud.com/bill']],
      ['Dropbox', ['dropbox', 'dropbox inc', 'dropbox.com']],
      ['OneDrive', ['onedrive', 'microsoft onedrive', 'onedrive storage']],
      ['Box', ['box.com', 'box sync', 'box inc', 'box cloud']],
      ['Backblaze', ['backblaze', 'backblaze b2']],
      ['Carbonite', ['carbonite', 'carbonite inc']],
      ['IDrive', ['idrive', 'idrive backup', 'idrive inc']],
      ['pCloud', ['pcloud ltd']],
      ['Sync.com', ['sync cloud storage']],
      
      // Productivity & Office
      ['Microsoft 365', ['microsoft 365', 'office 365', 'o365', 'msft', 'microsoft subscr', 'microsoft*office', 'microsoft*365']],
      ['Adobe Creative Cloud', ['adobe', 'adobe subscr', 'adobe systems', 'acrobat pro']],
      ['Notion', ['notion', 'notion labs']],
      ['Evernote', ['evernote', 'evernote corp']],
      ['Todoist', ['todoist', 'doist', 'todoist premium']],
      ['ClickUp', ['clickup', 'clickup.com']],
      ['Asana', ['asana', 'asana.com', 'asana premium']],
      ['Trello', ['trello', 'trello.com']],
      ['Monday.com', ['monday', 'monday.com inc']],
      ['Slack', ['slack', 'slack technologies']],
      ['Zoom', ['zoom', 'zoom.us', 'zoom video']],
      ['Grammarly', ['grammarly', 'grammarly inc']],
      ['Airtable', ['airtable', 'airtable.com']],
      ['Coda', ['coda.io']],
      ['Miro', ['miro', 'miro.com', 'realtimeboard']],
      ['Lucidchart', ['lucid software', 'lucidchart', 'lucidchart.com']],
      ['Dropbox Sign', ['hellosign', 'dropbox sign']],
      
      // Password Managers
      ['1Password', ['1password', '1password.com', 'agilebits']],
      ['LastPass', ['lastpass', 'logmein*lastpass', 'goto lastpass']],
      ['Dashlane', ['dashlane', 'dashlane.com']],
      ['Keeper', ['keeper security', 'keepersecurity.com']],
      ['NordPass', ['nordpass', 'nordsecurity', 'nord sec']],
      ['Bitwarden', ['bitwarden inc', 'bitwarden', 'bitwarden.com']],
      ['RoboForm', ['siber systems', 'roboform']],
      
      // Security Suites
      ['Norton', ['norton', 'nortonlifelock', 'norton 360', 'norton subscr']],
      ['McAfee', ['mcafee', 'mcafee*', 'mcafee.com']],
      ['Bitdefender', ['bitdefender', 'bitdefender sr', 'bitdefender subscription']],
      ['Kaspersky', ['kaspersky', 'kaspersky lab']],
      ['Malwarebytes', ['malwarebytes', 'malwarebytes corp']],
      ['LifeLock', ['lifelock', 'lifelock.com']],
      ['Aura', ['aura.com', 'aura identity theft']],
      
      // VPN Services
      ['NordVPN', ['nordvpn', 'nord vpn', 'nordvpn s.a.', 'nordvpn.com', 'nord security']],
      ['ExpressVPN', ['expressvpn', 'express vpn', 'express vpn intl', 'expressvpn.com']],
      ['Surfshark', ['surfshark', 'surfshark b.v.', 'surfshark.com']],
      ['Proton VPN', ['proton vpn', 'protonvpn', 'proton ag', 'protonmail vpn']],
      ['CyberGhost', ['cyberghost', 'cyberghost s.r.l.', 'cyberghostvpn']],
      ['Private Internet Access', ['private internet', 'pia', 'privateinternetaccess.com', 'private internet acc']],
      ['IPVanish', ['ipvanish', 'ipvanish.com']],
      ['TunnelBear', ['tunnelbear', 'tunnelbear inc']],
      ['Hotspot Shield', ['hotspot shield', 'anchorfree*hotspot']],
      ['Windscribe', ['windscribe', 'windscribe limited']],
      
      // Business SaaS / CRM / Marketing
      ['QuickBooks', ['quickbooks', 'qbooks', 'intuit', 'intuit*quickbooks', 'quickbooks online']],
      ['Xero', ['xero', 'xero limited']],
      ['FreshBooks', ['freshbooks', 'freshbooks cloud']],
      ['Wave', ['wave apps', 'waveapps', 'wave accounting']],
      ['Zoho', ['zoho', 'zoho corp', 'zoho subscr']],
      ['HubSpot', ['hubspot', 'hubspot inc', 'hubspot.com']],
      ['Salesforce', ['salesforce', 'salesforce.com', 'sfdc']],
      ['Mailchimp', ['mailchimp', 'intuit*mailchimp', 'mailchimp.com']],
      ['ConvertKit', ['convertkit', 'ck*convertkit']],
      ['ActiveCampaign', ['activecampaign', 'activecampaign llc']],
      ['Calendly', ['calendly', 'calendly llc']],
      ['DocuSign', ['docusign', 'docusign inc']],
      ['Typeform', ['typeform', 'typeform sl']],
      ['Jotform', ['jotform', 'jotform inc']],
      ['Shopify', ['shopify', 'shopify subscr', 'shopify.com']],
      ['BigCommerce', ['bigcommerce', 'bigcommerce inc']],
      ['Squarespace', ['squarespace', 'squarespace inc']],
      ['Wix', ['wix', 'wix.com ltd']],
      ['Webflow', ['webflow', 'webflow inc']],
      ['Stripe', ['stripe billing', 'stripe subscr']],
      ['Intercom', ['intercom', 'intercom r&d', 'intercom*']],
      ['Zendesk', ['zendesk', 'zendesk inc', 'zendesk*']],
      ['Freshdesk', ['freshworks', 'freshworks*', 'freshdesk']],
      ['Drift', ['drift', 'drift.com']],
      ['Pipedrive', ['pipedrive', 'pipedrive*']],
      ['Close', ['close.io']],
      ['Copper', ['copper crm']],
      
      // Developer / Design / DevOps
      ['GitHub', ['github', 'github.com', 'github suscription']],
      ['GitLab', ['gitlab', 'gitlab b.v.', 'gitlab subscr']],
      ['Bitbucket', ['bitbucket', 'bitbucket.org', 'atlassian bitbucket']],
      ['Atlassian', ['atlassian cloud', 'jira software', 'confluence']],
      ['AWS', ['aws', 'aws billing', 'amazon web services', 'aws e-bill']],
      ['Google Cloud', ['google cloud', 'gcp', 'google cloud platform', 'gcp billing']],
      ['Azure', ['azure', 'msft azure', 'microsoft*azure']],
      ['DigitalOcean', ['digitalocean', 'digitalocean llc']],
      ['Linode', ['linode', 'linode.com']],
      ['Heroku', ['heroku', 'heroku inc']],
      ['Vercel', ['vercel', 'vercel inc']],
      ['Netlify', ['netlify', 'netlify inc']],
      ['Figma', ['figma', 'figma inc']],
      ['Sketch', ['sketch', 'bohemian coding']],
      ['InVision', ['invision', 'invisionapp inc']],
      ['Postman', ['postman', 'postman inc']],
      ['JetBrains', ['jetbrains', 'jetbrains s.r.o.', 'jetbrains.com']],
      ['Sentry', ['sentry', 'sentry.io']],
      ['Datadog', ['datadog', 'datadog inc']],
      ['New Relic', ['new relic', 'new relic inc']],
      ['LogRocket', ['logrocket', 'logrocket inc']],
      ['Canva', ['canva', 'canva pty ltd', 'canva.com']],
      
      // News / Media / Publications
      ['New York Times', ['ny times', 'nytimes', 'newyorktimes', 'ny times digital', 'newyorktimes*']],
      ['Washington Post', ['washington post', 'washpost', 'washingtonpost.com']],
      ['Wall Street Journal', ['wsj', 'wall street journal', 'wsj subscr', 'dow jones*wsj']],
      ['Bloomberg', ['bloomberg', 'bloomberg lp', 'bloomberg.com subscr']],
      ['The Economist', ['economist', 'economist subscr']],
      ['Financial Times', ['ft.com subscr', 'financial times']],
      ['The Athletic', ['theathletic', 'theathletic.com']],
      ['Medium', ['medium', 'medium membership']],
      ['Substack', ['substack', 'substack.com', 'substack inc']],
      
      // Education / Learning
      ['Coursera', ['coursera', 'coursera.org']],
      ['Udemy', ['udemy', 'udemy*subscription', 'udemy business']],
      ['LinkedIn Learning', ['linkedin', 'linkedin*learning', 'lynda.com']],
      ['Skillshare', ['skillshare', 'skillshare inc']],
      ['MasterClass', ['masterclass', 'masterclass.com']],
      ['Codecademy', ['codecademy', 'codecademy*']],
      ['Duolingo', ['duolingo', 'duolingo plus']],
      ['Babbel', ['babbel', 'babbel gmbh']],
      ['Brilliant', ['brilliant', 'brilliant.org']],
      ['Khan Academy', ['khanacademy', 'khanacademy*donation', 'khan academy plus']],
      ['Pluralsight', ['pluralsight', 'pluralsight llc']],
      ['LeetCode', ['leetcode', 'leetcode.com']],
      ['AlgoExpert', ['algoexpert', 'algoexpert.io']],
      ['DataCamp', ['datacamp', 'datacamp inc']],
      
      // Telecom / Mobile / Internet
      ['Verizon', ['verizon', 'vzw', 'verizon wrls', 'verizon wireless', 'vzwrless*', 'verizon*onetime', 'verizon internet']],
      ['AT&T', ['att', 'at&t', 'att wireless', 'att*bill', 'att mobility', 'att u-verse']],
      ['T-Mobile', ['tmobile', 't-mobile', 't mobile', 't-mobile usa', 'tmobile*', 'metro by t-mobile']],
      ['Comcast', ['comcast', 'xfinity', 'comcast*bill', 'xfinity internet', 'xfinity mobile']],
      ['Spectrum', ['spectrum', 'spectrum*services', 'charter spectrum']],
      ['Cox', ['cox', 'cox cable', 'cox communications']],
      ['Google Fi', ['google fi', 'google*fi']],
      ['Mint Mobile', ['mint mobile', 'mintmobile.com']],
      ['Cricket Wireless', ['cricket wireless']],
      ['Boost Mobile', ['boost mobile', 'boost mobile*']],
      
      // Fitness / Gyms / Wellness
      ['Planet Fitness', ['planet fitness', 'planetfit', 'planetfit*', 'pf membership']],
      ['LA Fitness', ['la fitness', 'lafitness', 'lafitness*', 'la fitness dues']],
      ['24 Hour Fitness', ['24 hour fitness', '24hrfit', '24hrfit*', '24 hour fitness membership']],
      ['Anytime Fitness', ['anytime fitness', 'anytimefit', 'anytimefit*']],
      ['Orangetheory', ['orangetheory', 'orangetheory fit', 'otf membership']],
      ['Crunch', ['crunch', 'crunch fitness', 'crunch fitness*']],
      ['Peloton', ['peloton', 'peloton interactive', 'peloton subscription']],
      ['ClassPass', ['classpass', 'classpass inc']],
      ['Strava', ['strava', 'strava suscription', 'strava.com']],
      ['MyFitnessPal', ['myfitnesspal', 'under armour*myfitnesspal']],
      ['Noom', ['noom', 'noom inc']],
      ['WeightWatchers', ['weightwatchers', 'ww international', 'weight watchers']],
      ['Waking Up', ['sam harris waking up']],
      
      // Insurance
      ['State Farm', ['state farm', 'stfarm', 'stfarm*ins', 'statefarm*insurance']],
      ['GEICO', ['geico', 'geico*auto', 'geico insurance']],
      ['Progressive', ['progressive', 'progressive*pol', 'progressive ins']],
      ['Allstate', ['allstate', 'allstate*policy']],
      ['Farmers', ['farmers insurance', 'farmers ins grp']],
      ['Liberty Mutual', ['liberty mutual']],
      ['Nationwide', ['nationwide', 'nationwide ins']],
      ['USAA', ['usaa', 'usaa ins', 'usaa*insurance']],
      
      // Finance Tools
      ['YNAB', ['ynab', 'youneedabudget', 'youneedabudget.com']],
      ['Monarch Money', ['monarch', 'monarch money inc']],
      ['Simplifi', ['simplifi', 'simplifi by quicken']],
      ['Copilot Money', ['copilot', 'copilot.money']],
      ['Personal Capital', ['personalcapital', 'personalcapital.com']],
      ['Quicken', ['quicken', 'quicken inc']],
      
      // Shopping / Delivery
      ['Amazon Prime', ['amazon prime', 'amzn prime', 'amazon prime*membership', 'amzn prime member']],
      ['Walmart+', ['walmart', 'walmart+', 'wmt*plus', 'walmart membership']],
      ['Costco', ['costco', 'costco membership', 'costco wholesale mem']],
      ['Sam\'s Club', ['sams club', 'samsclub', 'samsclub*membership']],
      ['Instacart', ['instacart', 'instacart express', 'instacart+']],
      ['DoorDash', ['doordash', 'dashpass', 'doordash*subscription', 'dashpass*']],
      ['Uber One', ['uber one', 'uber*one', 'uber pass']],
      ['Lyft Pink', ['lyft pink', 'lyft*membership']],
      ['Grubhub+', ['grubhub', 'grubhub plus']],
      ['Shipt', ['shipt', 'shipt membership']],
      
      // Meal Kits
      ['HelloFresh', ['hellofresh', 'hellofresh us']],
      ['Blue Apron', ['blue apron', 'blueapron', 'blueapron.com']],
      ['Home Chef', ['home chef', 'homechef', 'homechef.com']],
      ['EveryPlate', ['everyplate', 'everyplate*']],
      ['Factor', ['factor', 'factor75', 'factor_75']],
      ['Daily Harvest', ['daily harvest', 'dailyharvest', 'dailyharvest*']],
      ['Green Chef', ['green chef', 'greenchef', 'greenchef*']],
      ['Sunbasket', ['sunbasket', 'sunbasket inc']],
      ['Misfits Market', ['misfits market', 'misfitsmarket']],
      
      // Lifestyle / Beauty Boxes
      ['Stitch Fix', ['stitch fix', 'stitchfix', 'stitchfix*']],
      ['Rent the Runway', ['rent the runway', 'renttherunway']],
      ['FabFitFun', ['fabfitfun', 'fabfitfun*']],
      ['Ipsy', ['ipsy', 'ipsy glam bag']],
      ['Birchbox', ['birchbox', 'birchbox*']],
      ['BoxyCharm', ['boxycharm', 'boxycharm*']],
      ['Scentbird', ['scentbird', 'scentbird*']],
      ['Dollar Shave Club', ['dollar shave club', 'dollarshaveclub']],
      ['Harry\'s', ['harrys', 'harrys.com']],
      ['Billie', ['billie', 'mybillie.com']],
      
      // Pets / Kids
      ['BarkBox', ['barkbox', 'barkbox.com']],
      ['Chewy Autoship', ['chewy', 'chewy*autoship']],
      ['Banfield Pet Hospital', ['banfield', 'banfield pet hospital']],
      ['KiwiCo', ['kiwico', 'kiwico inc']],
      ['ABCmouse', ['abcmouse', 'abcmouse.com']],
      ['Epic', ['getepic', 'getepic.com']],
      
      // Gaming
      ['Xbox', ['xbox', 'microsoft*xbox', 'xbox live', 'game pass ultimate']],
      ['PlayStation', ['playstation', 'psn', 'psn*playstation', 'sony*playstation']],
      ['Nintendo', ['nintendo', 'nintendo*eshop', 'nintendo*online']],
      ['EA Play', ['ea play', 'electronic arts*play']],
      ['Ubisoft+', ['ubisoft', 'ubisoft plus']],
      ['Steam', ['steam', 'valve*steam', 'steamgames.com']],
      ['Blizzard', ['blizzard', 'blizzard ent', 'battle.net subscription', 'blizzard*wow', 'wow subscription']],
      ['Riot Games', ['riot games', 'riot games*']],
      ['Final Fantasy XIV', ['square enix', 'square enix*online', 'ffxiv subscription']],
      
      // Creator / Social Tools
      ['Hootsuite', ['hootsuite', 'hootsuite*']],
      ['Buffer', ['buffer', 'buffer inc']],
      ['Later', ['later', 'later media', 'later.com']],
      ['Linktree', ['linktree', 'linktr.ee', 'linktree subscr']],
      ['StreamYard', ['streamyard', 'streamyard.com']],
      ['Riverside', ['riverside', 'riverside.fm']],
      
      // Time Tracking / HR
      ['Toggl', ['toggl', 'toggl.com']],
      ['Harvest', ['harvest', 'harvest*apps']],
      ['RescueTime', ['rescuetime', 'rescuetime inc']],
      ['Gusto', ['gusto', 'gusto payroll']],
      ['Rippling', ['rippling', 'rippling, inc.']],
      ['Justworks', ['justworks', 'justworks inc']],
      
      // Hosting / Domains / CDN
      ['GoDaddy', ['godaddy', 'godaddy.com', 'godaddy dom reg']],
      ['Namecheap', ['namecheap', 'namecheap.com']],
      ['Bluehost', ['bluehost', 'bluehost.com']],
      ['HostGator', ['hostgator', 'hostgator.com']],
      ['SiteGround', ['siteground', 'siteground hosting']],
      ['WP Engine', ['wpengine', 'wpengine.com']],
      ['Cloudflare', ['cloudflare', 'cloudflare inc']],
      ['Google Domains', ['google domains', 'google*domains']],
      
      // Beauty & Personal Care Boxes
      ['Birchbox', ['birchbox']],
      ['BoxyCharm', ['boxycharm']],
      
      // Subscription Boxes - Other
      ['BarkBox', ['barkbox']],
      ['KiwiCo', ['kiwico']],
      ['Dollar Shave Club', ['dollar shave']],
      ['Harry\'s', ['harrys', 'harry\'s']],
      ['Billie', ['billie razors']],
      
      // Coffee & Beverage
      ['Trade Coffee', ['trade coffee']],
      ['Blue Bottle', ['blue bottle']],
      ['Atlas Coffee', ['atlas coffee']],
      
      // Kids & Family
      ['ABCmouse', ['abcmouse']],
      ['Epic! Reading', ['epic reading']],
      ['Amazon Kids+', ['amazon kids']],
      
      // Creator Tools
      ['Canva Pro', ['canva']],
      ['Hootsuite', ['hootsuite']],
      ['Buffer', ['buffer']],
      ['Later', ['later.com']],
      ['Linktree', ['linktree']],
      ['StreamYard', ['streamyard']],
      ['Riverside.fm', ['riverside']],
      
      // Finance Tools
      ['YNAB', ['ynab', 'you need a budget']],
      ['Monarch Money', ['monarch money']],
      ['Simplifi', ['simplifi']],
      ['Copilot', ['copilot money']],
      
      // Web Hosting
      ['GoDaddy', ['godaddy']],
      ['Namecheap', ['namecheap']],
      ['Bluehost', ['bluehost']],
      ['HostGator', ['hostgator']],
      ['Cloudflare', ['cloudflare']],
      
      // Car Related
      ['Tesla Premium', ['tesla premium connectivity']],
      ['OnStar', ['onstar']],
      ['SiriusXM Auto', ['siriusxm', 'sirius xm']],
      
      // Pet Services
      ['Chewy Autoship', ['chewy']],
      ['Banfield', ['banfield']],
      
      // Beauty & Grooming
      ['Scentbird', ['scentbird']],
      ['Hims', ['forhims', 'hims']],
      ['Hers', ['forhers', 'hers']],
      ['Manscaped', ['manscaped']],
      
      // Dating & Social (more)
      ['BeReal', ['bereal']],
      
      // Meditation & Wellness (more)
      ['Insight Timer', ['insight timer']],
      ['10% Happier', ['10% happier', 'ten percent']],
      ['Waking Up', ['waking up']],
      
      // Professional Development
      ['LeetCode', ['leetcode']],
      ['AlgoExpert', ['algoexpert']],
      
      // Stock Assets
      ['Envato Elements', ['envato']],
      ['Storyblocks', ['storyblocks']],
      ['Epidemic Sound', ['epidemic sound']],
      ['Artlist', ['artlist']],
      ['Shutterstock', ['shutterstock']],
      
      // Music Production
      ['Splice', ['splice']],
      ['LANDR', ['landr']],
      
      // Time Tracking
      ['Toggl', ['toggl']],
      ['Harvest', ['harvest time']],
      ['RescueTime', ['rescuetime']],
      
      // CRM
      ['Pipedrive', ['pipedrive']],
      ['Close', ['close.com', 'close crm']],
      ['Copper', ['copper crm']],
      
      // Support Tools
      ['Zendesk', ['zendesk']],
      ['Intercom', ['intercom']],
      ['Drift', ['drift']],
      
      // HR & Payroll
      ['Gusto', ['gusto']],
      ['Rippling', ['rippling']],
      ['Justworks', ['justworks']],
      
      // Analytics
      ['Fathom Analytics', ['fathom']],
      ['ChartMogul', ['chartmogul']],
      ['Baremetrics', ['baremetrics']],

      // AI & Productivity Tools
      ['ChatGPT Plus', ['chatgpt', 'chatgpt plus', 'openai chatgpt', 'openai*chatgpt']],
      ['Claude Pro', ['claude pro', 'claude.ai', 'anthropic claude', 'anthropic*claude']],
      ['Perplexity Pro', ['perplexity', 'perplexity pro', 'perplexity ai']],
      ['Copy.ai', ['copy.ai', 'copy ai']],
      ['Jasper', ['jasper', 'jasper ai', 'jasper.ai']],
      ['Writesonic', ['writesonic', 'writesonic ai']],
      ['Rytr', ['rytr', 'rytr.me']],
      ['Midjourney', ['midjourney', 'mid journey']],
      ['Leonardo.ai', ['leonardo.ai', 'leonardo ai']],
      ['Runway ML', ['runway', 'runway ml', 'runwayml']],
      ['ElevenLabs', ['elevenlabs', 'eleven labs']],
      ['Synthesia', ['synthesia', 'synthesia.io']],
      ['Descript', ['descript', 'descript.com']],
      ['Otter.ai', ['otter', 'otter.ai']],
      ['Notably', ['notably', 'notably.ai']],
      ['Fireflies.ai', ['fireflies', 'fireflies.ai']],
      ['Rewind.ai', ['rewind', 'rewind.ai']],
      ['GrammarlyGO', ['grammarlygo', 'grammarly go']],

      // Cloud & Developer Infrastructure
      ['Render', ['render', 'render.com']],
      ['Fly.io', ['fly.io', 'fly io']],
      ['Supabase', ['supabase', 'supabase.com']],
      ['Railway', ['railway', 'railway.app']],
      ['MongoDB Atlas', ['mongodb atlas', 'mongo atlas', 'atlas mongodb']],
      ['PlanetScale', ['planetscale', 'planet scale']],
      ['Plaid', ['plaid', 'plaid.com']],
      ['Twilio', ['twilio', 'twilio.com']],
      ['Segment', ['segment', 'segment.com', 'segment io']],
      ['Clerk', ['clerk', 'clerk.com']],
      ['Auth0', ['auth0', 'auth zero']],
      ['Snyk', ['snyk', 'snyk.io']],
      ['HashiCorp Cloud', ['hashicorp cloud', 'hashicorp', 'hcp cloud']],

      // Finance, Taxes, and Credit
      ['TurboTax', ['turbotax', 'turbo tax', 'intuit turbotax']],
      ['H&R Block', ['h&r block', 'hr block', 'h and r block']],
      ['Credit Karma Premium', ['credit karma premium', 'credit karma']],
      ['Experian CreditWorks', ['experian creditworks', 'creditworks', 'experian premium']],
      ['MyFICO', ['myfico', 'my fico']],
      ['Rocket Money', ['rocket money', 'rocketmoney', 'truebill']],
      ['Billshark', ['billshark', 'bill shark']],
      ['Credit Sesame', ['credit sesame', 'creditsesame']],

      // Home & Security
      ['ADT', ['adt', 'adt security']],
      ['SimpliSafe', ['simplisafe', 'simpli safe']],
      ['Ring Protect', ['ring protect', 'ring subscription', 'ring.com']],
      ['Nest Aware', ['nest aware', 'google nest aware']],
      ['Arlo Secure', ['arlo secure', 'arlo subscription']],
      ['Vivint', ['vivint', 'vivint smart home']],
      ['Brinks Home', ['brinks home', 'brinks security']],
      ['Termly', ['termly', 'termly.io']],
      ['iubenda', ['iubenda', 'iubenda.com']],

      // Travel & Transportation
      ['TSA PreCheck', ['tsa precheck', 'precheck']],
      ['CLEAR Plus', ['clear plus', 'clear membership', 'clearme']],
      ['Priority Pass', ['priority pass', 'prioritypass']],
      ['AAA Membership', ['aaa membership', 'triple a', 'american automobile association']],
      ['Zipcar', ['zipcar', 'zip car']],
      ['Turo', ['turo', 'turo.com']],
      ['Hertz Gold Plus Rewards', ['hertz gold plus rewards', 'hertz gold plus', 'hertz rewards']],
      ['Enterprise Plus', ['enterprise plus', 'enterprise rewards']],
      ['Southwest WiFi Subscription', ['southwest wifi', 'southwest wi-fi', 'southwest internet']],
      ['Delta Sky Club', ['delta sky club', 'sky club']],
      ['United Club', ['united club', 'united airlines club']],
      ['Alaska Lounge', ['alaska lounge', 'alaska airlines lounge']],

      // News & Reading
      ['The New Yorker', ['new yorker', 'the new yorker']],
      ['Wired', ['wired', 'wired.com']],
      ['The Atlantic', ['the atlantic', 'atlantic subscription']],
      ['The Guardian Premium', ['guardian premium', 'the guardian premium']],
      ['Pocket Premium', ['pocket premium', 'read it later pocket']],
      ['Feedly Pro', ['feedly pro', 'feedly']],
      ['Scribd', ['scribd', 'scribd inc']],
      ['Book of the Month', ['book of the month', 'botm']],
      ['Audible Plus', ['audible plus', 'audible membership']],
      ['Comixology', ['comixology', 'comixology unlimited']],

      // Health & Wellness
      ['WW Digital', ['ww digital', 'weight watchers digital', 'weightwatchers digital']],
      ['Oura Membership', ['oura membership', 'oura ring subscription']],
      ['Whoop Membership', ['whoop membership', 'whoop subscription', 'whoop']],
      ['Fitbit Premium', ['fitbit premium', 'fitbit subscription']],
      ['Garmin Connect Premium', ['garmin connect premium', 'garmin premium']],
      ['Calm Business', ['calm business', 'calm for business']],
      ['OpenFit', ['openfit', 'open fit']],
      ['Les Mills+', ['les mills+', 'les mills plus', 'les mills']],
      ['Centr', ['centr', 'centr app', 'chris hemsworth centr']],
      ['Future Fitness', ['future fitness', 'future app fitness']],
      ['BetterHelp', ['betterhelp', 'better help']],
      ['Talkspace', ['talkspace', 'talk space']],
      ['Headway', ['headway', 'headway app']],

      // Shopping, Food & Lifestyle
      ['Thrive Market', ['thrive market', 'thrivemarket']],
      ['ButcherBox', ['butcherbox', 'butcher box']],
      ['Wildgrain', ['wildgrain', 'wild grain']],
      ['Crowd Cow', ['crowd cow', 'crowdcow']],
      ['Imperfect Foods', ['imperfect foods', 'misfits market imperfect foods']],
      ['FreshDirect', ['freshdirect', 'fresh direct']],
      ['MeUndies', ['meundies', 'me undies']],
      ['Fabletics', ['fabletics', 'fabletics vip']],
      ['Savage X Fenty', ['savage x fenty', 'savagexfenty']],
      ['Care/of', ['care/of', 'care of vitamins']],
      ['Ritual', ['ritual vitamins', 'ritual subscription']],
      ['HelloBello', ['hellobello', 'hello bello']],
      ["The Farmer's Dog", ["the farmer's dog", 'the farmers dog', 'farmers dog']],
      ['Nom Nom', ['nom nom now', 'nomnom', 'nom nom']],
      ['Peloton App+', ['peloton app+', 'peloton app plus', 'peloton digital']],

      // Gaming & Digital Content
      ['Roblox Premium', ['roblox premium', 'roblox subscription']],
      ['Fortnite Crew', ['fortnite crew', 'epic games crew']],
      ['Xbox Game Pass Ultimate', ['xbox game pass ultimate', 'game pass ultimate']],
      ['PlayStation Plus', ['playstation plus extra', 'playstation plus premium', 'ps plus extra', 'ps plus premium']],
      ['EA Play Pro', ['ea play pro', 'electronic arts play pro']],
      ['Humble Choice', ['humble choice', 'humble bundle choice']],
      ['GOG Galaxy', ['gog galaxy', 'gog.com subscription']],
      ['Itch.io Supporter', ['itch.io supporter', 'itch supporter', 'itch io subscription']],
      ['GeForce NOW', ['geforce now', 'nvidia geforce now']],
      ['Shadow PC', ['shadow pc', 'shadow.tech']],

      // Education & Skill
      ['Educative.io', ['educative.io', 'educative io']],
      ['DataQuest', ['dataquest', 'data quest']],
      ['Memrise Pro', ['memrise pro', 'memrise premium']],
      ['Sololearn Pro', ['sololearn pro', 'solo learn pro']],
      ['Brilliant Premium', ['brilliant premium', 'brilliant.org premium']],
      ['edX Plus', ['edx plus', 'edx premium', 'edx+']],
      ['Rosetta Stone', ['rosetta stone', 'rosettastone']],
      ['Sketchfab', ['sketchfab', 'sketchfab premium']],
      ['Domestika', ['domestika', 'domestika plus']],
      ['The Odin Project Supporter', ['the odin project supporter', 'odin project supporter']],

      // Business, Marketing & CRM
      ['Zoho One', ['zoho one', 'zoho suite']],
      ['Keap', ['keap', 'infusionsoft', 'keap infusionsoft']],
      ['Pabbly', ['pabbly', 'pabbly connect']],
      ['Zapier', ['zapier', 'zapier inc']],
      ['Make', ['make.com', 'integromat', 'make automation']],
      ['Airtable Pro', ['airtable pro', 'airtable premium']],
      ['Typefully', ['typefully', 'typefully.com']],
      ['Beehiiv', ['beehiiv', 'beehiiv.com']],
      ['ConvertBox', ['convertbox', 'convert box']],
      ['Carrd Pro', ['carrd pro', 'carrd.co pro', 'carrd pro standard']],
      ['ClickFunnels', ['clickfunnels', 'click funnels']],
      ['Kajabi', ['kajabi', 'kajabi.com']],
      ['Teachable', ['teachable', 'teachable.com']],
      ['Thinkific', ['thinkific', 'thinkific.com']],
      ['Podia', ['podia', 'podia.com']],

      // Analytics & Monitoring
      ['Ahrefs', ['ahrefs', 'ahrefs.com']],
      ['SEMrush', ['semrush', 'sem rush']],
      ['Moz Pro', ['moz pro', 'moz.com pro', 'moz subscription']],
      ['Ubersuggest', ['ubersuggest', 'uber suggest']],
      ['Hotjar', ['hotjar', 'hotjar.com']],
      ['Crazy Egg', ['crazyegg', 'crazy egg']],
      ['FullStory', ['fullstory', 'full story']],
      ['Mixpanel', ['mixpanel', 'mix panel']],
      ['Heap', ['heap analytics', 'heap.io', 'heap']],
      ['Statcounter', ['statcounter', 'stat counter']],

      // Additional User Suggestions (Batch 2)
      ['Discovery+ Max', ['discovery+ max', 'discovery max', 'max discovery', 'hbomax discovery', 'discovery plus max']],
      ['Paramount+ with SHOWTIME', ['paramount+ with showtime', 'paramount plus showtime', 'showtime on paramount', 'paramount showtime bundle']],
      ['BritBox International', ['britbox international', 'britbox intl']],
      ['Acorn TV', ['acorn tv', 'acorn.tv']],
      ['Crackle Plus', ['crackle plus', 'crackle premium']],
      ['Plex Pass', ['plex pass', 'plex premium']],
      ['Viki Pass', ['viki pass', 'rakuten viki pass']],
      ['Kocowa+', ['kocowa+', 'kocowa plus', 'kocowa']],
      ['Shudder', ['shudder', 'shudder subscription']],
      ['Kanopy Plus', ['kanopy plus', 'kanopy premium']],
      ['Tubi Premium', ['tubi premium', 'tubi plus']],
      ['Rakuten TV', ['rakuten tv', 'rakutentv']],
      ['Pluto TV Plus', ['pluto tv plus', 'pluto plus']],
      ['Hayu', ['hayu', 'hayu subscription']],
      ['Cineverse', ['cineverse', 'cineverse plus']],
      ['Gaia', ['gaia', 'gaia subscription']],
      ['Nebula', ['nebula', 'nebula streaming']],
      ['Revry', ['revry', 'revry plus']],

      ['Deezer', ['deezer', 'deezer premium']],
      ['Napster', ['napster', 'napster music']],
      ['Mixcloud Pro', ['mixcloud pro', 'mixcloud premium']],
      ['Beatport Streaming', ['beatport streaming', 'beatport']],
      ['Primephonic', ['primephonic', 'apple music classical', 'apple classical']],
      ['Idagio', ['idagio', 'idagio premium']],
      ['Sonos Radio HD', ['sonos radio hd', 'sonos hd radio']],
      ['Audm', ['audm', 'audm subscription']],
      ['Curio', ['curio', 'curio audio']],

      ['Affinity Suite', ['affinity suite', 'affinity designer', 'affinity photo', 'affinity publisher']],
      ['CorelDRAW', ['coreldraw', 'corel draw', 'corel subscription']],
      ['Magix', ['magix', 'magix software']],
      ['Capture One', ['capture one', 'captureone']],
      ['DaVinci Resolve Studio', ['davinci resolve studio', 'davinci studio', 'blackmagic davinci']],
      ['Filmora Pro', ['filmora pro', 'wondershare filmora']],
      ['Topaz Labs', ['topaz labs', 'topaz photo ai', 'topaz video ai']],
      ['LottieFiles', ['lottiefiles', 'lottie files']],
      ['Clip Studio Paint', ['clip studio paint', 'csp subscription']],
      ['Artbreeder Plus', ['artbreeder plus', 'artbreeder premium']],
      ['RunDiffusion', ['rundiffusion', 'run diffusion']],
      ['Pika Labs', ['pika labs', 'pika ai']],
      ['Kittl', ['kittl', 'kittl pro']],
      ['Motion Array', ['motion array', 'motionarray']],
      ['Font Awesome Pro', ['font awesome pro', 'fontawesome pro']],
      ['Vectornator Pro', ['vectornator pro', 'linearity pro', 'vectornator']],
      ['UpdraftPlus', ['updraft plus', 'updraftplus', 'updraftplus premium']],

      ['Replit', ['replit', 'replit core', 'replit teams']],
      ['Obsidian Sync', ['obsidian sync', 'obsidian publish', 'obsidian subscription']],
      ['ReadMe', ['readme', 'readme.com']],
      ['Appsmith Cloud', ['appsmith cloud', 'appsmith']],
      ['Postmark', ['postmark', 'postmarkapp']],
      ['SendGrid', ['sendgrid', 'twilio sendgrid']],
      ['Mailgun', ['mailgun', 'mailgun technologies']],
      ['Cloudinary', ['cloudinary', 'cloudinary.com']],
      ['Imgix', ['imgix', 'imgix.com']],
      ['Mux', ['mux', 'mux.com']],
      ['Databricks', ['databricks', 'databricks cloud']],
      ['Snowflake', ['snowflake', 'snowflake computing']],
      ['Grafana Cloud', ['grafana cloud', 'grafana labs']],
      ['PagerDuty', ['pagerduty', 'pager duty']],
      ['Statuspage', ['statuspage', 'atlassian statuspage']],
      ['Raygun', ['raygun', 'raygun io']],
      ['UptimeRobot Pro', ['uptimerobot pro', 'uptime robot pro']],
      ['Honeybadger', ['honeybadger', 'honeybadger.io']],
      ['LaunchDarkly', ['launchdarkly', 'launch darkly']],
      ['Featurebase', ['featurebase', 'featurebase.app']],

      ['Todo Cloud', ['todo cloud', 'todocloud']],
      ['ClickFunnels Classic', ['clickfunnels classic', 'click funnels classic']],
      ['Groove.cm', ['groove.cm', 'groove cm', 'groovefunnels']],
      ['Kartra', ['kartra', 'kartra.com']],
      ['ActiveCampaign CRM', ['activecampaign crm', 'active campaign crm']],
      ['Constant Contact', ['constant contact', 'constantcontact']],
      ['Campaign Monitor', ['campaign monitor', 'campaignmonitor']],
      ['Omnisend', ['omnisend', 'omnisend.com']],
      ['Smartsheet', ['smartsheet', 'smart sheet']],
      ['Wrike', ['wrike', 'wrike.com']],
      ['Podio', ['podio', 'podio.com']],
      ['Basecamp', ['basecamp', 'base camp']],
      ['Flow Task Manager', ['flow task manager', 'flow app tasks', 'getflow']],
      ['Collato', ['collato', 'collato.com']],
      ['Fellow.app', ['fellow.app', 'fellow app', 'fellow']],
      ['Hypercontext', ['hypercontext', 'hyper context']],
      ['Calendly Teams', ['calendly teams', 'calendly team plan']],
      ['Motion Calendar', ['motion calendar app', 'usemotion', 'motion app']],
      ['Sunsama', ['sunsama', 'sunsama.com']],
      ['Timeular', ['timeular', 'timeular app']],
      ['Clockify Premium', ['clockify premium', 'clockify pro']],

      ['ProtonMail', ['protonmail', 'proton mail', 'proton mail plus']],
      ['Tutanota', ['tutanota', 'tuta mail']],
      ['StartMail', ['startmail', 'start mail']],
      ['Fastmail', ['fastmail', 'fastmail.com']],
      ['Skiff', ['skiff', 'skiff mail']],
      ['SimpleLogin', ['simplelogin', 'simple login']],
      ['AnonAddy', ['anonaddy', 'anon addy', 'addy.io']],
      ['Ghostery Premium', ['ghostery premium', 'ghostery plus']],
      ['AdGuard', ['adguard', 'ad guard']],
      ['Disconnect Premium', ['disconnect premium', 'disconnect.me premium']],
      ['CleanMyMac X', ['cleanmymac x', 'clean my mac x']],
      ['CCleaner Professional', ['ccleaner professional', 'ccleaner pro']],
      ['Intego', ['intego', 'intego security']],
      ['Malwarebytes Premium', ['malwarebytes premium', 'malwarebytes plus']],
      ['Avast Security', ['avast security', 'avast premium']],
      ['AVG Ultimate', ['avg ultimate', 'avg internet security']],

      ['Rocket Mortgage+', ['rocket mortgage+', 'rocket mortgage plus', 'rocketmortgage subscription']],
      ['Simplifi by Quicken', ['simplifi by quicken', 'quicken simplifi', 'simplifi']],
      ['Empower', ['empower personal capital', 'empower finance', 'personal capital empower']],
      ['Truebill Legacy', ['truebill legacy', 'truebill old']],
      ['Capital One Shopping+', ['capital one shopping+', 'capital one shopping plus']],
      ['Experian IdentityWorks', ['experian identityworks', 'identityworks']],
      ['FICO Advanced', ['fico advanced', 'myfico advanced']],
      ['MyIDCare', ['myidcare', 'my id care']],
      ['Privacy.com Pro', ['privacy.com pro', 'privacy dot com pro', 'privacy.com premium']],
      ['Brex', ['brex', 'brex card']],
      ['Ramp', ['ramp', 'ramp card']],
      ['Divvy', ['divvy', 'divvy card']],
      ['Expensify', ['expensify', 'expenseify']],

      ['Apple Fitness+', ['apple fitness+', 'apple fitness plus']],
      ['Fitbod', ['fitbod', 'fitbod app']],
      ['Future Fit', ['future fit', 'future fitness']],
      ['Ladder Fitness', ['ladder fitness', 'join ladder']],
      ['Centr Premium', ['centr premium', 'centr app premium']],
      ['Sweat', ['sweat app', 'kayla itsines sweat']],
      ['FitOn Pro', ['fiton pro', 'fiton premium']],
      ['JEFIT Elite', ['jefit elite', 'jefit premium']],
      ['Nike Training Club Premium', ['nike training club premium', 'ntc premium']],
      ['Garmin Golf Membership', ['garmin golf membership', 'garmin golf premium']],
      ['8fit Pro', ['8fit pro', 'eightfit pro']],
      ['YogaGlo', ['yogaglo', 'glo yoga']],
      ['Alo Moves', ['alo moves', 'alomoves']],
      ['Hyperice Membership', ['hyperice membership', 'hyperice x']],
      ['Calm Premium Business', ['calm premium business', 'calm business premium']],
      ['Noom Mood', ['noom mood', 'noom mood plan']],
      ['FabFitFun Wellness Box', ['fabfitfun wellness box', 'fabfitfun wellness']],
      ['Care/of Vitamins', ['care/of vitamins', 'care of vitamins']],
      ['Ritual Vitamins', ['ritual vitamins plan', 'ritual vitamin plan']],
      ['Hims Hair Plan', ['hims hair plan', 'forhims hair']],

      ['Thrive Market+', ['thrive market+', 'thrive market plus']],
      ['Public Goods', ['public goods', 'publicgoods']],
      ['Ecosia Tree Membership', ['ecosia tree membership', 'ecosia membership']],
      ['Grove Collaborative', ['grove collaborative', 'grove.co']],
      ['Butternut Box', ['butternut box', 'butternutbox']],
      ['Rebel Pet Feed', ['rebel pet feed', 'rebelpetfood']],
      ['Open Farm Autoship', ['open farm autoship', 'openfarm autoship']],
      ['Ollie', ['ollie', 'myollie']],
      ['PetPlate', ['petplate', 'pet plate']],
      ['PupBox', ['pupbox', 'pup box']],
      ['CatLadyBox', ['catladybox', 'cat lady box']],
      ['Meowbox', ['meowbox', 'meow box']],
      ['Universal Yums', ['universal yums', 'universalyums']],
      ['Bokksu', ['bokksu', 'bokksu subscription']],
      ['SnackCrate', ['snackcrate', 'snack crate']],
      ['MunchPak', ['munchpak', 'munch pak']],
      ["Harry's", ['harrys', "harry's"]],
      ['Dollar Beard Club', ['dollar beard club', 'dollarbeardclub']],

      ['FedEx Delivery Manager Premium', ['fedex delivery manager premium', 'fedex premium delivery manager']],
      ['UPS My Choice Premium', ['ups my choice premium', 'ups premium mychoice']],
      ['USPS Informed Delivery', ['usps informed delivery', 'informed delivery premium']],
      ['Amazon Subscribe & Save', ['amazon subscribe save', 'amazon subscribe and save']],
      ['Best Buy TotalTech', ['best buy totaltech', 'bestbuy totaltech']],
      ['Dell SupportAssist Premium', ['dell supportassist premium', 'supportassist premium']],
      ['HP Instant Ink', ['hp instant ink', 'instant ink']],
      ['Adobe Acrobat Pro', ['adobe acrobat pro', 'acrobat pro subscription']],
      ['PDF Expert Premium', ['pdf expert premium', 'pdfexpert premium']],
      ['Foxit PDF Editor', ['foxit pdf editor', 'foxit editor premium']],

      ['Brilliant Premium+', ['brilliant premium+', 'brilliant premium plus']],
      ['Course Hero', ['course hero', 'coursehero']],
      ['Chegg Study', ['chegg study', 'chegg']],
      ['Quizlet Plus', ['quizlet plus', 'quizlet premium']],
      ['Bartleby Learn', ['bartleby learn', 'bartleby']],
      ['Preply', ['preply', 'preply subscription']],
      ['Skillshare Teams', ['skillshare teams', 'skillshare team plan']],
      ['LingQ', ['lingq', 'ling q']],
      ['FluentU', ['fluentu', 'fluent u']],
      ['italki Credits', ['italki credits', 'italki']],
      ['Babbel Live', ['babbel live', 'babbel classes']],
      ['Elevate', ['elevate app', 'elevate premium']],
      ['Lumosity', ['lumosity', 'lumosity premium']],
      ['Brilliant for Teams', ['brilliant for teams', 'brilliant teams']],
      ['Outlier.org', ['outlier.org', 'outlier org']],
      ['Memrise for Business', ['memrise for business', 'memrise business']],

      ['OnStar Premium', ['onstar premium', 'onstar subscription premium']],
      ['Tesla Connectivity Premium', ['tesla connectivity premium', 'premium connectivity tesla']],
      ['Rivian Connect+', ['rivian connect+', 'rivian connect plus']],
      ['BMW ConnectedDrive', ['bmw connecteddrive', 'bmw connected drive']],
      ['Porsche Connect', ['porsche connect', 'porsche connect services']],
      ['Audi Connect', ['audi connect', 'audi connect plus']],
      ['Car Wash Club', ['car wash club', 'unlimited wash club']],
      ['AAA Motor Club', ['aaa motor club', 'triple a motor club']],
      ['Good Sam Club', ['good sam club', 'goodsam club']],
      ['Disney Annual Pass', ['disney annual pass', 'disney passholder']],
      ['National Park Pass', ['national park pass', 'america the beautiful pass', 'national parks pass']],
      ['CLEAR Sports Pass', ['clear sports pass', 'clear stadium pass']]
    ];

export const normalizeForMatch = (value = '') => {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const normalizeServiceKey = (value = '') => {
  return normalizeForMatch(value).replace(/\s+/g, '');
};

export const findServiceNameByText = (text = '') => {
  const normalizedText = normalizeForMatch(text);
  if (!normalizedText) return null;

  const safeWordBoundaryMatch = (haystack, needle) => {
    if (!needle) return false;
    const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(^|\\b|\\s)${escaped}(\\b|\\s|$)`, 'i');
    return re.test(haystack);
  };

  for (const [serviceName, keywords] of SHARED_SERVICE_KEYWORDS) {
    for (const keyword of keywords) {
      const k = normalizeForMatch(String(keyword || ''));
      if (!k) continue;

      const isShort = k.length <= 3;
      const isAmbiguous = ['max'].includes(k);
      const matched = (isShort || isAmbiguous)
        ? safeWordBoundaryMatch(normalizedText, k)
        : normalizedText.includes(k);

      if (matched) return serviceName;
    }
  }

  return null;
};
